<div class="dropdown-menu cart-dropdown">

  <a [routerLink]="[cartPageUrl]"
     class="cart-link"
     fxLayout="row"
     fxLayoutGap="5px"
     fxLayoutAlign="center center">

    <img src="assets/images/icon/basket.svg"
         alt="cart">

    <span class="cart-title" [ngClass]="{'move-up': !cartStateValue && isExistShoppingCart() && !(shoppingCartState && shoppingCartState.isNotEmpty())}"> {{'shared.labels.myBasket'|translate}}</span>

    <span class="cart-count">{{ticketCount$|async}}</span>

  </a>
</div>

<!-- <span>1:35</span> -->


